import { handleActions } from "redux-actions";

import {
	getListAsyncAction,
	postManyAsyncAction,
	truncateAsyncAction,
} from "./instagramActions";

const defaultAjaxState = {
	response: null,
	error: null,
	loading: false,
};

const initialState = {
	list: defaultAjaxState,
	post_many: defaultAjaxState,
	truncate: defaultAjaxState,
};

export const instagramReducer = handleActions(
	new Map([
		// get list
		[
			getListAsyncAction.request,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					loading: true,
				},
			}),
		],
		[
			getListAsyncAction.success,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					response: payload,
				},
			}),
		],
		[
			getListAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				list: {
					...initialState.list,
					error: payload,
				},
			}),
		],

		// post many
		[
			postManyAsyncAction.request,
			(state, { payload }) => ({
				...state,
				post_many: {
					...initialState.post_many,
					loading: true,
				},
			}),
		],
		[
			postManyAsyncAction.success,
			(state, { payload }) => ({
				...state,
				post_many: {
					...initialState.post_many,
					response: payload,
				},
			}),
		],
		[
			postManyAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				post_many: {
					...initialState.post_many,
					error: payload,
				},
			}),
		],

		// truncate
		[
			truncateAsyncAction.request,
			(state, { payload }) => ({
				...state,
				truncate: {
					...initialState.truncate,
					loading: true,
				},
			}),
		],
		[
			truncateAsyncAction.success,
			(state, { payload }) => ({
				...state,
				truncate: {
					...initialState.truncate,
					response: payload,
				},
			}),
		],
		[
			truncateAsyncAction.failure,
			(state, { payload }) => ({
				...state,
				truncate: {
					...initialState.truncate,
					error: payload,
				},
			}),
		],
	]),
	initialState
);
